// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__ZObtG","title":"AfterFrontImage_title__3e5GV"};